/* The theme's live layer. Runs on every Shopify page straight after site-data.js, before anything draws.
   The pages were built on a snapshot of the store (assets/shopify-data.js, data.js, pdpdata.js). On Shopify the
   theme's Liquid puts the live facts on the page and this script folds them in:
     window.LIVE_PRODUCT    the product page's product (Liquid `product | json`): live prices, stock, variant ids
     window.LIVE_PLANS      its selling plan groups (Subscribe & Save)
     window.LIVE_COLLECTION the collection page's products, in Shopify's order, with live prices and stock
   It also owns the basket: Shopify's cart (/cart.js, /cart/add.js, /cart/change.js). A product's variants are
   looked up live from /products/<handle>.js when first needed. Nothing here is used by the local preview
   (window.THEME_LIVE is only set by layout/theme.liquid). */
(function () {
  'use strict';
  if (!window.THEME_LIVE) return;
  var SH = window.SHOPIFY, PP = window.PP, BY = window.PP_BY_HANDLE || (window.PP_BY_HANDLE = {});
  if (!SH || !PP) return;
  /* the store's Judge.me score and review count, live (shop.metafields.judgeme) */
  var LSr = window.LIVE_SHOP && window.LIVE_SHOP.reviews;
  if (LSr && +LSr.count > 0 && PP.content && PP.content.rating) { PP.content.rating.score = (parseFloat(LSr.rating) || 0).toFixed(1); PP.content.rating.count = String(LSr.count); }
  function pounds(c) { return Math.round(Number(c) || 0) / 100; }
  function img(u) { return u ? String(u).replace(/^\/\//, 'https://') : null; }

  /* a live product record ({handle,title,brand,productType,tags,price,priceMax,compareAt,available,variants,img,
     firstVariant,rating,reviewCount,blurb}) is written over the snapshot, or added when the snapshot never saw it */
  function reg(lp) {
    var h = lp.handle; if (!h) return;
    var sp = BY[h];
    if (!sp) {
      sp = { handle: h, title: lp.title || h, brand: lp.brand || '', price: lp.price, priceMax: lp.priceMax, compareAt: lp.compareAt || null, productType: lp.productType || '', tags: lp.tags || [],
        rating: lp.rating || 0, reviewCount: lp.reviewCount || 0, blurb: lp.blurb || '', subscription: !!lp.subscription, img: null, cdn: img(lp.img), available: !!lp.available, variants: lp.variants || 1 };
      SH.products.push(sp); BY[h] = sp;
    } else {
      if (lp.title) sp.title = lp.title;
      if (lp.brand) sp.brand = lp.brand;
      if (lp.price != null) sp.price = lp.price;
      if (lp.priceMax != null) sp.priceMax = lp.priceMax;
      sp.compareAt = lp.compareAt || null;
      if (lp.available != null) sp.available = !!lp.available;
      if (lp.variants) sp.variants = lp.variants;
      if (lp.img && !sp.cdn && !sp.img) sp.cdn = img(lp.img);
      if (lp.rating != null && lp.reviewCount) { sp.rating = lp.rating; sp.reviewCount = lp.reviewCount; }
    }
    if (lp.firstVariant) sp.firstVariant = lp.firstVariant;
    var pp = PP.products[h];
    if (!pp) {
      PP.products[h] = { h: h, t: sp.title, b: sp.brand, ty: sp.productType, p: sp.price, c: sp.compareAt, a: sp.available, rc: sp.reviewCount || 0, rv: sp.rating || 0, nv: sp.variants || 1,
        img: img(lp.img), imgw: 600, imgh: 600, png: false, gallery: [], rk: 9999 };
    } else {
      if (lp.title) pp.t = lp.title;
      if (lp.brand) pp.b = lp.brand;
      if (lp.price != null) pp.p = lp.price;
      pp.c = lp.compareAt || null;
      if (lp.available != null) pp.a = !!lp.available;
      if (lp.img && !pp.img) pp.img = img(lp.img);
    }
  }

  /* the collection page: Shopify's own list and order, live prices */
  var LC = window.LIVE_COLLECTION;
  if (LC && LC.handle) {
    (LC.products || []).forEach(reg);
    var c = SH.collections[LC.handle];
    if (!c) c = SH.collections[LC.handle] = { title: LC.title || LC.handle, description: '', paragraphs: [], image: null, products: [] };
    if (LC.title) c.title = LC.title;
    c.products = (LC.products || []).map(function (p) { return p.handle; });
  }

  /* the product page: live prices, stock and variant ids on the snapshot's variants */
  var cache = {};
  var LP = window.LIVE_PRODUCT;
  function fromShopifyProduct(P) {
    var avail = P.variants.filter(function (v) { return v.available; });
    return { handle: P.handle, title: P.title, brand: P.vendor, productType: P.type, tags: P.tags || [], price: pounds(P.price_min), priceMax: pounds(P.price_max),
      compareAt: P.compare_at_price_max > P.price_max ? pounds(P.compare_at_price_max) : null, available: !!P.available, variants: P.variants.length,
      img: P.featured_image, firstVariant: (avail[0] || P.variants[0] || {}).id };
  }
  function patchVars(P) {
    var D = window.PPD && window.PPD[P.handle];
    if (!D || !D.vars) return;
    D.vars.forEach(function (v, i) {
      var lv = P.variants.filter(function (x) { return x.title === v.t; })[0] || P.variants[i];
      if (!lv) return;
      v.id = lv.id; v.p = pounds(lv.price); v.c = lv.compare_at_price ? pounds(lv.compare_at_price) : null; v.a = !!lv.available;
    });
  }
  if (LP && LP.handle) { cache[LP.handle] = Promise.resolve(LP); reg(fromShopifyProduct(LP)); patchVars(LP); }   /* pdpdata.js runs later and calls PPLIVE.patchVars again */

  /* variants, live, when the basket needs one */
  function product(h) {
    if (!cache[h]) cache[h] = fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('product ' + r.status); return r.json(); })
      .then(function (P) { reg(fromShopifyProduct(P)); patchVars(P); return P; });
    return cache[h];
  }
  /* a basket key is a handle, or "handle::i" for variant i of pdpdata's list (matched to Shopify by its title) */
  function variantFor(key) {
    var bits = String(key).split('::'), h = bits[0], i = bits.length > 1 ? Number(bits[1]) : -1;
    return product(h).then(function (P) {
      var vs = P.variants || [];
      if (i < 0) return vs.filter(function (v) { return v.available; })[0] || vs[0];
      var D = window.PPD && window.PPD[h], t = D && D.vars && D.vars[i] ? D.vars[i].t : null;
      return (t && vs.filter(function (v) { return v.title === t; })[0]) || vs[i] || vs[0];
    });
  }
  /* the selling plan id for a plan option name ("Deliver every 12 weeks") on a product */
  function planFor(h, option) {
    return product(h).then(function (P) {
      var groups = (h === (LP && LP.handle) && window.LIVE_PLANS) || P.selling_plan_groups || [], found = null;
      groups.forEach(function (g) { (g.selling_plans || []).forEach(function (pl) { if (!found && option && String(pl.name).toLowerCase().indexOf(String(option).toLowerCase()) > -1) found = pl.id; }); });
      if (!found && groups[0] && groups[0].selling_plans && groups[0].selling_plans[0]) found = groups[0].selling_plans[0].id;
      return found;
    });
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j && (j.description || j.message) || ('cart ' + r.status)); return j; }); });
  }
  function cartGet() { return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function cartAdd(key, qty, option) {
    var h = String(key).split('::')[0];
    return Promise.all([variantFor(key), option ? planFor(h, option) : null]).then(function (r) {
      var v = r[0], plan = r[1]; if (!v) throw new Error('no variant for ' + key);
      var item = { id: v.id, quantity: qty || 1 }; if (plan) item.selling_plan = plan;
      return post('/cart/add.js', { items: [item] });
    });
  }
  function cartChange(line, qty) { return post('/cart/change.js', { line: line, quantity: qty }); }
  /* which basket key a Shopify cart line is */
  function keyOf(item) {
    var h = item.handle, D = window.PPD && window.PPD[h];
    if (D && D.vars && D.vars.length > 1 && item.variant_title) {
      var i = -1; D.vars.forEach(function (v, k) { if (i < 0 && v.t === item.variant_title) i = k; });
      if (i >= 0) return h + '::' + i;
    }
    return h;
  }
  /* a cart line's product is registered so the drawer can draw it even if the snapshot never saw it */
  function regItem(it) {
    if (BY[it.handle]) { if (it.vendor) { BY[it.handle].brand = it.vendor; if (PP.products[it.handle]) PP.products[it.handle].b = it.vendor; } return; }
    reg({ handle: it.handle, title: it.product_title, brand: it.vendor, productType: it.product_type, tags: [], price: pounds(it.price), priceMax: pounds(it.price), compareAt: null, available: true, variants: 1, img: it.featured_image && it.featured_image.url, firstVariant: it.variant_id });
  }
  window.PPLIVE = { reg: reg, patchVars: patchVars, product: product, variantFor: variantFor, planFor: planFor, cartGet: cartGet, cartAdd: cartAdd, cartChange: cartChange, keyOf: keyOf, regItem: regItem, pounds: pounds };
})();

/* "Write a review" opens Judge.me's own review pop-up. Judge.me loads its pop-up code because the product page carries a
   (hidden) Judge.me review block (snippets/judgeme-form); the pop-up is made on the first click and shown with Judge.me's
   own styles. If Judge.me has not loaded, the button's e-mail link still works. */
(function () {
  if (!window.THEME_LIVE) return;
  var modal = null;
  var ready = null, readyId = null;
  function prepare(id) {
    id = id || window.LIVE_PRODUCT.id;
    if (ready && readyId === id) return ready;
    /* Judge.me's form styles live beside its other widget styles (the app's own CDN folder) */
    var base = Array.prototype.map.call(document.querySelectorAll('link[rel=stylesheet]'), function (l) { return l.href; }).filter(function (h) { return /widget_v3_base\.css/.test(h); })[0];
    if (base && !document.querySelector('link[data-jdgm-form]')) { var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = base.replace('widget_v3_base.css', 'widget_v3_form.css'); l.setAttribute('data-jdgm-form', ''); document.head.appendChild(l); }
    /* the pop-up calls a helper that only loads with Judge.me's full review list; without it the pop-up stops after the stars */
    if (typeof jdgm._rtlStarsEnabled !== 'function') jdgm._rtlStarsEnabled = function () { return false; };
    modal = new jdgm._WriteReviewModal(jdgm.$);
    readyId = id;
    ready = modal.setup('jdgm-review-widget-modal', id);
    return ready;
  }
  function open(id, fallback) { prepare(id).then(function () { modal.showModalPage(); }, fallback || function () { var b = document.querySelector('[data-ppwr]'); if (b) location.href = b.getAttribute('href'); }); }
  /* the reviews page: any product can be reviewed. The page picks the product, this looks up its id and opens the same
     Judge.me pop-up; if Judge.me is not there the shopper goes to that product's page, where the button is. */
  window.PPWriteReview = function (handle) {
    var back = function () { location.href = '/products/' + handle; };
    if (!window.jdgm || !jdgm._WriteReviewModal || !jdgm.$) return back();
    window.fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (r) { return r.json(); }).then(function (p) { open(p.id, back); }, back);
  };
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ppwr]'); if (!b) return;
    if (!window.jdgm || !jdgm._WriteReviewModal || !jdgm.$ || !window.LIVE_PRODUCT) return;
    e.preventDefault(); open();
  });
})();

/* newsletter: after Shopify takes the sign-up the page reloads with ?customer_posted=true; show the thank-you and the code,
   or Shopify's own reason if it said no (for example an address that is already signed up) */
(function () {
  if (!window.THEME_LIVE) return;
  function show() {
    var f = document.querySelector('form.nl'); if (!f) return false;
    var ok = document.getElementById('nl-real-ok') || /[?&]customer_posted=true/.test(location.search);
    var err = document.getElementById('nl-real-err');
    if (!ok && !err) return true;
    if (ok) { f.hidden = true; if (f.nextElementSibling) f.nextElementSibling.hidden = false; }
    else { var p = f.querySelector('.nl-err') || document.createElement('p'); p.className = 'nl-err'; p.textContent = err.getAttribute('data-msg') || 'That did not go through. Please try again.'; f.appendChild(p); }
    f.closest('.fnl, footer, .nlbox') && (f.closest('.fnl, footer, .nlbox')).scrollIntoView({ block: 'center' });
    return true;
  }
  /* the footer box becomes Shopify's own newsletter form (form_type customer, tagged newsletter): Shopify's spam check binds
     itself when the shopper clicks into the email box, exactly as on any Shopify theme */
  function native(f) {
    if (f.hasAttribute('data-native')) return;
    f.setAttribute('data-native', '');
    f.setAttribute('action', '/contact#nl-real'); f.setAttribute('method', 'post'); f.setAttribute('accept-charset', 'UTF-8');
    var em = f.querySelector('input[type=email]'); if (em) { em.name = 'contact[email]'; em.required = true; }
    [['form_type', 'customer'], ['utf8', '\u2713'], ['contact[tags]', 'newsletter']].forEach(function (x) {
      var i = document.createElement('input'); i.type = 'hidden'; i.name = x[0]; i.value = x[1]; f.appendChild(i);
    });
  }
  var tries = 0; (function wait() { var f = document.querySelector('form.nl'); if (f) native(f); if ((!f || !show()) && tries++ < 60) setTimeout(wait, 150); })();
})();

/* ---- the account page must never show the made-up example account on the store ----
   If, a few seconds after the page loads, the example note is still showing (the real account never took over),
   the page is replaced by a plain message with the technical reason, which is also written to the console. */
(function () {
  if (!window.THEME_LIVE || !/\/pages\/account-dashboard/.test(location.pathname)) return;
  var errs = [];
  window.addEventListener('error', function (e) { errs.push(String(e.message) + ' @' + String(e.filename || '').split('/').pop() + ':' + e.lineno); });
  window.addEventListener('unhandledrejection', function (e) { errs.push('promise: ' + String(e.reason)); });
  function check() {
    var ex = document.querySelector('.ac-ex'), live = document.querySelector('[data-ac].ac-live');
    if (live || !ex) return;
    var A = window.PP_ACCT || {}, d = A.data || null;
    var px = window.__ppProxy ? JSON.stringify(window.__ppProxy) : 'no answer yet';
    var why = ['address: ' + location.pathname, 'account app replied: ' + px, 'customer on page: ' + (A.customer ? 'yes' : 'no'), 'account data on page: ' + (d ? ('yes, ' + ((d.orders || []).length) + ' orders, ' + ((d.addresses || []).length) + ' addresses') : 'no'), 'script errors: ' + (errs.length ? errs.join(' | ') : 'none')];
    try { console.error('[account] made-up example account was still showing; ' + why.join('; ')); } catch (e) {}
    var m = document.getElementById('main'); if (!m) return;
    m.innerHTML = '<div class="wrap" style="padding:56px 16px 72px;max-width:680px"><h1 style="font:400 34px/1.15 var(--serif);color:var(--teal);margin:0 0 12px">We could not load your account</h1>' +
      '<p style="margin:0 0 16px">Your orders are safe. Please refresh the page, or <a href="mailto:hello@poorly-pet.com">email us</a> and we will help.</p>' +
      '<details open style="font-size:14px;color:#55655F"><summary style="cursor:pointer">Technical details (for the site developer)</summary><pre style="white-space:pre-wrap;margin:8px 0 0">' + why.join('\n').replace(/[<&]/g, function (c) { return c === '<' ? '&lt;' : '&amp;'; }) + '</pre></details></div>';
  }
  setTimeout(check, 12000);   /* the account app gets time to answer first */
})();

/* Choosing a variant shows that variant's own photo: the product page tells us which variant was picked, and the gallery
   moves to the photo Shopify has set for it (matched by file name). Variants with no photo of their own leave it alone. */
(function () {
  if (!window.THEME_LIVE) return;
  function key(u) { return String(u || '').split('?')[0].split('/').pop().replace(/_\d+x\d*(?=\.)/, '').toLowerCase(); }
  document.addEventListener('n2:variant', function (e) {
    var LP = window.LIVE_PRODUCT; if (!LP || !e.detail) return;
    var v = (LP.variants || []).filter(function (x) { return String(x.id) === String(e.detail.id); })[0];
    var fi = v && (v.featured_image || (v.featured_media && v.featured_media.preview_image)); if (!fi || !fi.src) return;
    var k = key(fi.src), idx = -1;
    [].slice.call(document.querySelectorAll('.n2-slide img')).forEach(function (im, i) { if (idx < 0 && key(im.currentSrc || im.src) === k) idx = i; });
    if (idx < 0) return;
    var th = document.querySelector('.n2-th[data-gi="' + idx + '"]');
    if (th) th.click();
  });
})();

(function () {
  if (!window.THEME_LIVE || !(window.LIVE_SHOP && window.LIVE_SHOP.customer)) return;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-open="account"]'); if (!b) return;
    e.preventDefault(); e.stopPropagation(); location.href = '/pages/account-dashboard';
  }, true);
  document.addEventListener('DOMContentLoaded', function () {
    [].forEach.call(document.querySelectorAll('[data-open="account"]'), function (b) { if (/^\s*Sign in\s*$/.test(b.textContent)) b.textContent = 'Account'; });
  });
})();
